module.exports = __webpack_public_path__ + "assets/img/yiduihuan.2effe870.png";